module.exports = __webpack_public_path__ + "images/pro/pro-logo-huge-6a8fead619d606dcbf3ada8015d55d6a.png";